import { Component, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
declare const Calendly: any;
interface Feature {
  title: string;
  description: string;
  image: string;
  isHovered: boolean;
  imageOnly: boolean;
}

@Component({
  selector: 'app-e-concierge-management',
  templateUrl: './e-concierge-management.component.html',
  styleUrls: ['./e-concierge-management.component.css']
})
export class EConciergeManagementComponent {
  @ViewChild('scrollableContainer', { static: false }) scrollableContainer!: ElementRef;
  @ViewChild('scrollableContainerFeedbackManagement', { static: false }) scrollableContainerFeedbackManagement!: ElementRef;
  mobile: boolean = false;
  public calendlyUrl = environment.CALENDLY_URL;

  features: Feature[] = [
    {
      title: 'Guest Profiles',
      description: `Maintain detailed records of preferences, past stays, and special requests.`,
      image: 'assets/images/Guest Profiles1.png',
      isHovered: false,
      imageOnly: false
    },
    {
      title: 'Proactive Service',
      description: 'Anticipate guest needs and deliver services before they ask.',
      image: 'assets/images/Proactive Service.png',
      isHovered: false,
      imageOnly: false
    },
    {
      title: 'Special Occasions',
      description: 'Celebrate birthdays, anniversaries, or milestones with tailored offerings.',
      image: 'assets/images/Special Occasions.png',
      isHovered: false,
      imageOnly: false
    },
    {
      title: 'Customizable Rules',
      description: 'Set parameters to align pricing with your revenue goals.',
      image: 'assets/images/spa-image7.png',
      isHovered: false,
      imageOnly: true
    },
    {
      title: 'Benefit',
      description: 'Enhance guest loyalty, create unique experiences, and drive repeat business.',
      image: 'assets/images/Benefit-image4.png',
      isHovered: false,
      imageOnly: false
    },
    {
      title: 'Market Comparisons',
      description: 'Stay competitive with insights into local market rates.',
      image: 'assets/images/spa-image8.png',
      isHovered: false,
      imageOnly: true
    },
  ];

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth();
  }

  constructor(private router: Router) { }
  ngOnInit() {
    this.checkScreenWidth();
  }

  private checkScreenWidth() {
    if (window.innerWidth <= 1250) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  onHover(feature: Feature) {
    if (!this.mobile && !feature.imageOnly) {
      feature.isHovered = true;
    }
  }

  onLeave(feature: Feature) {
    if (!this.mobile && !feature.imageOnly) {
      feature.isHovered = false;
    }
  }
  openCalendlyPopup() {
    Calendly.initPopupWidget({ url: this.calendlyUrl });
    return false;
  }

  selectTrial() {
    this.router.navigateByUrl('free-trial');
    window.scrollTo(0, 0);
  }

  bannerScrollRight(): void {
    this.scrollableContainer.nativeElement.scrollTo({
      left: this.scrollableContainer.nativeElement.scrollLeft + 250,
      behavior: 'smooth'
    });
  }

  bannerScrollLeft(): void {
    this.scrollableContainer.nativeElement.scrollTo({
      left: this.scrollableContainer.nativeElement.scrollLeft - 250,
      behavior: 'smooth'
    });
  }

  bannerScrollRight1(): void {
    this.scrollableContainerFeedbackManagement.nativeElement.scrollTo({
      left: this.scrollableContainerFeedbackManagement.nativeElement.scrollLeft + 500,
      behavior: 'smooth'
    });
  }

  bannerScrollLeft1(): void {
    this.scrollableContainerFeedbackManagement.nativeElement.scrollTo({
      left: this.scrollableContainerFeedbackManagement.nativeElement.scrollLeft - 500,
      behavior: 'smooth'
    });
  }

}
